import { render, staticRenderFns } from "./veStuRewardTypeShow.vue?vue&type=template&id=99fa5c78&scoped=true"
import script from "./veStuRewardTypeShow.vue?vue&type=script&lang=js"
export * from "./veStuRewardTypeShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fa5c78",
  null
  
)

export default component.exports